// https://github.com/moment/moment/issues/3650
// since we are using ts 3.5.1, it should be safe to remove.
export default function interopDefault(m) {
    return m.default || m;
}



// WEBPACK FOOTER //
// ./components/_util/interopDefault.ts